import { EventsManager } from "./eventsManager";
declare const gantt;
if (!gantt.ext) {
	gantt.ext = {};
}

gantt.ext.dragTimeline = {
	create: () => EventsManager.create()
};

gantt.config.drag_timeline = {
	enabled: true
};